import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { ProjectsEditorService, ProjectsService } from '@app/services/app/projects.service';
import { VersionsService, VersionsViewService } from '@app/services/app/versions.service';

import * as Objects from '@core/objects';
import { TitleService } from '@core/services/title.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/services/app/app.service';
import { AccessProject } from '@app/models/access';

@Component({
    selector: 'version-add-main',
    templateUrl: './version-add.component.html',
    styleUrls: ['./version-add.component.scss']
})
export class ProjectDetailsVersionAddComponent implements OnInit, OnDestroy {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_ERROR = 2;
    public readonly STATUS_NOT_ALLOWED = 3;
    public readonly STATUS_GROUP_TAGS_NOT_ALLOWED = 4;

    public readonly ACCESS_UPLOAD_VERSION = "access_request_upload_version";
    public readonly ACCESS_VERSION_NO_FILE = "access_version_upload_no_file"; // will be required file allways
    public readonly ACCESS_UPLOAD_VERSION_EDIT_TAGS = "access_request_upload_version_edit_labels";


    public project: Objects.Request = null;
    public labels: Array<Objects.Label> = null;
    public breadcrumbTitle: string = 'UPLOAD NEW ARTWORK'; //  TO NEW TAG GROUP


    public uploadVersionAccess: boolean = null;
    public editVersionTagsAccess: boolean = false;
    public context: string = '';
    public versionNumber: string = '1.0';
    public breadcrumbs: any = [
        {
            title: "Project <small>(# .  .  . )</small>",
            link: ''
        }
    ];

    public status:number = this.STATUS_LOADING;

    protected links: string = '';
    protected urlSubscriptor: Subscription;
    protected versionLabelsSubscriptor: Subscription;
    protected projectSubscriptor: Subscription;
    protected accessProjectSubscriptor: Subscription;


    constructor(
        public app: AppService,
        private title: TitleService,
        private activeRoute: ActivatedRoute,
        private projectsSrv: ProjectsService,
        private viewVersionsSrv: VersionsViewService,
        private versionsSrv: VersionsService,
        private projectEditorSrv: ProjectsEditorService,
        private router: Router
    ) { }

    ngOnInit() {
        // set temporal header title
        this.title.set("Version Add - Project...");

        this.projectSubscriptor = this.projectsSrv.selectProject().subscribe((project: Objects.Request) => {
            // console.log(" PROJECT UPDATED  ",project.labels)
            // if tags are different, then need to reload the related to check if available
            if(this.project && this.project.labels.length != project.labels.length){
                this.getRelatedGroupVersionLabels();
            }
            this.project = project;
            this.initView();
        });

        this.urlSubscriptor = this.activeRoute.queryParams.subscribe((params: any) => {
            // console.log(" params ", params);

            if (params.links){
                this.links = params.links;
            } 
            this.getRelatedGroupVersionLabels();


        });
        // subscribe to upload version access
        this.accessProjectSubscriptor = this.projectEditorSrv.selectAccessAll().subscribe((access: AccessProject) => {
            if(access != null){
                // console.log("access",access)
                this.uploadVersionAccess = access[this.ACCESS_UPLOAD_VERSION];
                if (!this.uploadVersionAccess)
                    this.status = this.STATUS_NOT_ALLOWED;
                this.editVersionTagsAccess = access[this.ACCESS_UPLOAD_VERSION_EDIT_TAGS];

                this.initView();
            }
        });

    }

    ngOnDestroy() {
        this.urlSubscriptor.unsubscribe();
        this.projectSubscriptor.unsubscribe();
        this.accessProjectSubscriptor.unsubscribe();
        this.versionLabelsSubscriptor?.unsubscribe();
        this.viewVersionsSrv.clear();
    }

    private initView() {
        if( this.status == this.STATUS_NOT_ALLOWED || this.project == null || this.labels == null || this.uploadVersionAccess == null)
            return;
        this.updateBreadcrumbs();
        // check all tags in project are in version except no tags in links url param
        if(this.labels.length > 0 && !this.project.labels.every((pl: Objects.Label) => 
            this.labels.some((vl:Objects.Label) => vl.id === pl.id)
          )){
            this.status = this.STATUS_GROUP_TAGS_NOT_ALLOWED;
            return;
          }
        this.setHeaderTitle();
        this.updateBreadcrumbs();
        this.status = this.STATUS_DONE;
    }

    private setHeaderTitle() {
        this.title.set("Version Add - Project #" + this.project.id);
    }

    protected updateBreadcrumbs(){
        if(this.project == null)
            return;

        this.breadcrumbs[0].link = '/projects/'+this.project.id;
        this.breadcrumbs[0].title = 'Project <small>(#'+this.project.id+ ')</small>';
    }

    private getRelatedGroupVersionLabels() : void {
        if (this.links != ''){
            this.versionLabelsSubscriptor = this.versionsSrv.getVersionsGroup$(this.links).subscribe((versions: Array<Objects.Version>) => {
                // console.debug(" versions in group loaded ",versions);
                if(versions != null && versions.length >0 ){
                    this.labels = versions[0].labels;
                    this.versionNumber = versions[0].version;
                    this.initView();
                } else{
                    this.labels = [];
                    this.initView();
                }
            });
        } else {
            this.labels = [];
            this.initView();
        }
        
    }

}